export const CUSTOMER_STATUS_DELETED = -2
export const CUSTOMER_STATUS_DISABLED = 0
export const CUSTOMER_STATUS_ENABLED = 1
